import { HexMark } from '@/components/brand/HexMark'
import { en } from '@/i18n/en'

/**
 * Rendered when /config.js is missing or invalid. Deliberately has no providers (no Clerk, no
 * router, no i18n init) — it must work when everything else cannot. Copy comes from the base
 * dictionary directly.
 */
export function ConfigErrorScreen({ issues }: { issues: string[] }) {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-0 px-4 py-10">
      <div className="w-full max-w-lg min-w-0 rounded-xl border border-border-subtle bg-surface-1 p-6 shadow-2 sm:p-8">
        <div className="mb-5 flex items-center gap-3">
          <HexMark className="size-10" muted />
          <p className="font-mono text-xs text-text-tertiary">{en.app.name}</p>
        </div>
        <h1 className="text-xl text-text-primary">{en.config.title}</h1>
        <p className="mt-2 text-text-secondary">{en.config.body}</p>
        <h2 className="mt-6 text-sm font-medium text-text-primary">{en.config.issues}</h2>
        <ul className="mt-2 flex flex-col gap-1.5">
          {issues.map((i) => (
            <li key={i} className="rounded-sm bg-danger-subtle px-3 py-2 font-mono text-xs break-words text-danger">
              {i}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
